export default "__VITE_ASSET__DPn$M1Gw__"